import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import { i18nReady } from './i18n';
import App from './App';
import { initSentry } from '@/lib/sentry';
import { initPostHog } from '@/lib/posthog';
import { captureResetToken } from '@/lib/resetToken';

// MUST stay above initSentry/initPostHog: both read window.location, and
// PostHog captures a pageview with the full URL on init. A reset token in the
// query string would be shipped to a third party before React ever mounts.
captureResetToken();

initSentry();
initPostHog();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found in index.html');
}

// Render only once the starting locale is in the i18next store — see i18nReady.
void i18nReady.finally(() => {
  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
